import { useQuery } from '@tanstack/react-query';
import { CampaignsService } from '../services';
import { campaignsKeys } from '../queryKeys';
import { READ_ONLY_QUERY_OPTIONS } from '../queryConfig';

/**
 * One professional's campaign eligibility history, in the order the service
 * returns it. Read-only, so no invalidation surface (see READ_ONLY_QUERY_OPTIONS
 * for why retry and refetch-on-focus are off).
 */
export const useGetProfessionalCampaigns = (professionalId, options) => {
  const {
    data, error, isError, isLoading, isFetching,
  } = useQuery({
    queryKey: campaignsKeys.professionalCampaigns(professionalId),
    queryFn: () => CampaignsService.getProfessionalCampaigns(professionalId),
    enabled: options?.enabled ?? !!professionalId,
    ...READ_ONLY_QUERY_OPTIONS,
  });

  return {
    campaigns: data || [],
    error,
    isError,
    isLoading: isLoading || isFetching,
  };
};
